import { Component, Inject } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Action, ActionCreator, Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { DA_DELIVERABLES } from '../../../../da-engineer/new-workplan/new-workplan-flow.constants';
import { importMandatoryChecks } from 'src/app/roles/da-engineer/global-settings/store/global-settings.actions';
import { checkForProjectDeliverablesImportDuplicates, importProjectDeliverables } from 'src/app/roles/da-engineer/project-deliverables/store/project-deliverables.actions';
import { ImportObjectTypes } from 'src/app/roles/da-engineer/screening/screening.constants';
import { checkForDADeliverablesImportDuplicates, importDADeliverables } from 'src/app/roles/da-engineer/screening/store/screening.actions';
import { FileParameter } from 'src/app/shared/models/autogenerated';

@Component({
  standalone: false,
  selector: 'app-import-excel-dialog',
  templateUrl: './import-excel-dialog.component.html',
  styleUrls: ['./import-excel-dialog.component.scss'],
})
export class ImportExcelDialogComponent {
  readonly importObjectType: string;
  readonly onSuccessStoreAction: ActionCreator<
    string,
    () => Action<string>
  > | null;
  onlyAdd: boolean = true;
  insert: boolean = false;
  update: boolean = false;
  delete: boolean = false;
  addAll: boolean = false;
  readonly DaDeliverables = DA_DELIVERABLES;

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<ImportExcelDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      importObjectType: string;
      onSuccessStoreAction: ActionCreator<string, () => Action<string>> | null;
    }
  ) {
    this.importObjectType = data.importObjectType;
    this.onSuccessStoreAction = data.onSuccessStoreAction;
  }

  onAddAllChanged(event: MatCheckboxChange) {
    if (event.checked) {
      this.onlyAdd = false;
      this.insert = false;
      this.update = false;
      this.delete = false;
    }
  }

  unclickIncrementalOptions() {
    this.insert = false;
    this.update = false;
    this.delete = false;
  }

  onClick(e: any) {
    e.preventDefault();

    this.onlyAdd = true;
    this.unclickIncrementalOptions();
  }

  onCheckboxChanged(action: string, check: MatCheckboxChange) {
    if (this.addAll) {
      this.addAll = false;
    }

    if (check.checked === false) {
      this.onlyAdd =
        this.insert === false && this.update === false && this.delete === false;

      return;
    }

    if (action === 'onlyAdd') {
      this.unclickIncrementalOptions();
    } else {
      this.onlyAdd = false;
    }
  }

  closeWindow(): void {
    this.dialogRef.close();
  }

  importExcel(fileInput: HTMLInputElement | null) {
    this.importExcelFile(
      fileInput,
      this.store,
      this.onlyAdd,
      this.insert,
      this.delete,
      this.update,
      this.importObjectType,
      this.onSuccessStoreAction,
      this.addAll
    );

    this.closeWindow();
  }
  
  importExcelFile(
    fileInput: HTMLInputElement | null,
    store: Store,
    onlyAdd: boolean,
    insertMissing: boolean,
    removeDeleted: boolean,
    updateExisting: boolean,
    importObjectType: ImportObjectTypes,
    onSuccessStoreAction: ActionCreator<string, () => Action<string>> | null,
    addAll: boolean
  ) {
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      return;
    }
  
    const fileToUpload = fileInput.files[0];
    const fileParameter: FileParameter = {
      data: fileToUpload,
      fileName: fileToUpload.name,
    };
  
    if (addAll) {
      store.dispatch(
        checkForDADeliverablesImportDuplicates({
          file: fileParameter,
        })
      );
  
      store.dispatch(
        checkForProjectDeliverablesImportDuplicates({
          file: fileParameter,
          onSuccessStoreAction: onSuccessStoreAction!,
        })
      );
    } else {
      switch (importObjectType) {
        case ImportObjectTypes.DA_DELIVERABLES:
          if (onlyAdd) {
            store.dispatch(
              checkForDADeliverablesImportDuplicates({
                file: fileParameter,
              })
            );
          } else {
            store.dispatch(
              importDADeliverables({
                file: fileParameter,
                onlyAdd,
                insertMissing,
                removeDeleted,
                updateExisting,
              })
            );
          }
          break;
  
        case ImportObjectTypes.PROJECT_DELIVERABLES:
          if (onlyAdd) {
            store.dispatch(
              checkForProjectDeliverablesImportDuplicates({
                file: fileParameter,
                onSuccessStoreAction: onSuccessStoreAction!,
              })
            );
          } else {
            store.dispatch(
              importProjectDeliverables({
                file: fileParameter,
                onlyAdd,
                insertMissing,
                removeDeleted,
                updateExisting,
                onSuccessStoreAction: onSuccessStoreAction!,
              })
            );
          }
          break;
  
        case ImportObjectTypes.MANDATORY_CHECKS:
          store.dispatch(
            importMandatoryChecks({
              file: fileParameter,
              onlyAdd,
              insertMissing,
              removeDeleted,
              updateExisting,
            })
          );
          break;
  
        default:
          break;
      }
    }
  
    // reset file input to enable re-upload
    fileInput.value = '';
  }
  
}
